import { useState } from 'react'
import {
  BORDER,
  TrendArrow,
  formatChf,
  sectionStyle,
  sectionTitleStyle,
} from './analyseShared'

const SIGNAL_DOT = {
  green: '#34d399',
  yellow: '#fbbf24',
  red: '#f87171',
}

function RecBadge({ rec }) {
  const [open, setOpen] = useState(false)
  if (!rec) return '—'
  const color = SIGNAL_DOT[rec.color] || SIGNAL_DOT.yellow
  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <span style={{ width: 8, height: 8, borderRadius: 2, background: color, flexShrink: 0 }} />
      <span
        style={{ cursor: 'help', borderBottom: '1px dotted rgba(255,255,255,0.2)' }}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        {rec.label}
      </span>
      {open && (
        <span
          style={{
            position: 'absolute',
            right: 0,
            top: '100%',
            marginTop: 8,
            zIndex: 20,
            minWidth: 220,
            maxWidth: 320,
            padding: '10px 12px',
            fontSize: 11,
            lineHeight: 1.45,
            background: '#1a1f2e',
            border: BORDER,
            borderRadius: 4,
            color: 'var(--text-secondary)',
            boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
          }}
        >
          {rec.tooltip}
        </span>
      )}
    </span>
  )
}

export function SectionComparaisonSegments({ data, loading, error }) {
  if (loading) {
    return (
      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>3 — Comparaison segments</h2>
        <p style={{ color: 'var(--muted)', fontSize: 13 }}>Chargement…</p>
      </section>
    )
  }
  if (error) {
    return (
      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>3 — Comparaison segments</h2>
        <p style={{ color: '#fca5a5', fontSize: 13 }}>{error}</p>
      </section>
    )
  }
  if (!data) return null

  return (
    <section style={sectionStyle}>
      <h2 style={sectionTitleStyle}>3 — Comparaison segments</h2>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ borderBottom: BORDER, color: 'var(--text-tertiary)', fontSize: 11, textTransform: 'uppercase' }}>
              <th style={{ textAlign: 'left', padding: '10px 12px' }}>Segment</th>
              <th style={{ textAlign: 'right', padding: '10px 12px' }}>Volume marché</th>
              <th style={{ textAlign: 'right', padding: '10px 12px' }}>Prix médian</th>
              <th style={{ textAlign: 'right', padding: '10px 12px' }}>Délai vente</th>
              <th style={{ textAlign: 'right', padding: '10px 12px' }}>Tendance 90j</th>
              <th style={{ textAlign: 'left', padding: '10px 12px' }}>Recommandation</th>
            </tr>
          </thead>
          <tbody>
            {(data.rows || []).map((row) => (
              <tr key={row.segment} style={{ borderBottom: BORDER }}>
                <td style={{ padding: '14px 12px', fontWeight: 500 }}>{row.segment}</td>
                <td style={{ padding: '14px 12px', textAlign: 'right' }}>{row.volume_marche}</td>
                <td style={{ padding: '14px 12px', textAlign: 'right' }}>{formatChf(row.prix_median)}</td>
                <td style={{ padding: '14px 12px', textAlign: 'right' }}>{row.delai_vente != null ? `${row.delai_vente} j` : '—'}</td>
                <td style={{ padding: '14px 12px', textAlign: 'right' }}>
                  <TrendArrow pct={row.tendance_90j_pct} />
                </td>
                <td style={{ padding: '14px 12px' }}>
                  <RecBadge rec={row.recommandation} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
